import React, { Component } from 'react';
import Selectable from './selectable';
import classNames from 'classnames';
import { getSafeRandom } from '@platform/api'
function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (getSafeRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export default function hoc(App) {
    if (!App) {
        return console.error('缺少传入组件');
    }

    return class MetaTable extends Component {
        constructor(props) {
            super(props);
            this.uuid = uuidv4();
        }

        render() {

            let {
                high_selectable = {},
                ...others
            } = this.props;

            let uniqueSelector = `selectable-${this.uuid}`;

            let {
                unitKey = "rowid",
                selector = " tbody tr ",
                canvas = '.' + uniqueSelector,
                disabled = false, // 可选值 true false 'shift' 'ctrl' 'slide'
                // 启用用户文字选中
                userSelect = false,
                enable = true,
                unitsData = [],
                // 开始项  主要配合外部的 单选事件处理
                startItem = '',
                onSelect,
            } = high_selectable;

            return <div className={classNames(uniqueSelector, 'selectable-canvas', { 'selectable-canvas-enabled': enable })}>
                {enable &&
                    <Selectable
                        canvas={canvas}
                        selector={selector}
                        unitKey={unitKey}
                        disabled={disabled} // 可选值 true false 'shift' 'ctrl' 'slide'
                        userSelect={userSelect} // 启用用户文字选中
                        unitsData={unitsData}
                        // 开始项  主要配合外部的 单选事件处理
                        startItem={startItem}
                        onSelect={(sd, hotkey, { currentKey }) => {
                            console.log(sd, hotkey, currentKey);
                            onSelect && onSelect(sd, hotkey, { currentKey });
                            //ctrl 为单选
                            // if (hotkey == 'ctrl' && meta.status !== 'edit' && config.showCheck) {
                            //     let table = this.state.table,
                            //         rows = table.rows || [];
                            //     for (let index = 0; index < rows.length; index++) {
                            //         let iitem = rows[index],
                            //             values = iitem.values;
                            //         if (values && values.saga_status && values.saga_status.value === '1') {
                            //             continue;
                            //         }
                            //         if (!iitem.disabled && iitem['rowid'] == currentKey) {
                            //             // console.log(iitem, index, currentKey, 'ctrl 操作了');
                            //             onCheckboxChange.call(this, moduleId, null, iitem, index, config, pageScope);
                            //             return;
                            //         }
                            //     }
                            // } else if (meta.status !== 'edit' && config.showCheck) {
                            //     onRowSelectable.call(this, moduleId, null, config, pageScope, true, sd);
                            // }
                        }}
                    />
                }
                <App
                    {...others}
                />
            </div>
        }
    }
}